module.exports = __webpack_public_path__ + "img/email-icon.cf34bc3a.svg";